import { useState } from 'react';

/** Cómo se muestran las listas de órdenes: tarjetas (la de siempre) o tabla. */
export type OrderView = 'cards' | 'table';

// La vista elegida se recuerda en este dispositivo y la comparten el panel y la ficha del cliente.
const VIEW_KEY = 'miyama:orders-view';

function readView(): OrderView {
  try {
    return localStorage.getItem(VIEW_KEY) === 'table' ? 'table' : 'cards';
  } catch {
    return 'cards';
  }
}

export function useOrderView(): [OrderView, (view: OrderView) => void] {
  const [view, setView] = useState(readView);

  function changeView(next: OrderView) {
    setView(next);
    try {
      localStorage.setItem(VIEW_KEY, next);
    } catch {
      // Sin almacenamiento: la vista cambia igual, solo no se recuerda.
    }
  }

  return [view, changeView];
}
